<template>
    <b-modal
        :id="'admin-accounts-update-user-modal' + user.id"
        :title="$t('admin.edit_user')"
        :ok-title="$t('common.save')"
        @ok="save($event)"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @show="show">
        <b-form-group
            id="input-group-1"
            :label="$t('common.first_name')"
            label-for="input-1">
            <b-alert
                v-if="nameError"
                show
                variant="danger">
                {{ $t('validation.first_name_mandatory') }}
            </b-alert>

            <b-form-input
                id="input-1"
                v-model="name"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-2"
            :label="$t('common.infix')"
            label-for="input-2">
            <b-form-input
                id="input-2"
                v-model="preposition"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-3"
            :label="$t('common.last_name')"
            label-for="input-3">
            <b-alert
                v-if="surnameError"
                show
                variant="danger">
                {{ $t('validation.last_name_mandatory') }}
            </b-alert>

            <b-form-input
                id="input-3"
                v-model="surname"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-4"
            :label="$t('common.email')"
            label-for="input-4">
            <b-form-input
                id="input-4"
                v-model="email"
                type="email"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-5"
            :label="$t('common.username')"
            label-for="input-5">
            <b-alert
                v-if="usernameError"
                show
                variant="danger">
                {{ $t('admin.username_mandatory') }}
            </b-alert>

            <b-form-input
                id="input-5"
                v-model="username"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-6"
            :label="$t('common.password')"
            label-for="input-6">
            <b-alert
                v-if="passwordError"
                show
                variant="danger">
                {{ $t('admin.password_mandatory') }}
            </b-alert>

            <b-form-input
                id="input-6"
                v-model="password"
                type="password"></b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-admin-accounts-index-update-account-modal-component',
    props: ['user'],
    data() {
        return {
            nameError: false,
            surnameError: false,
            usernameError: false,
            passwordError: false,
            name: this.user.name,
            preposition: this.user.preposition,
            surname: this.user.surname,
            email: this.user.email,
            username: this.user.username,
            password: this.user.password,
        };
    },
    methods: {
        show() {
            this.nameError = false;
            this.surnameError = false;
            this.usernameError = false;
            this.passwordError = false;
            this.name = this.user.name;
            this.preposition = this.user.preposition;
            this.surname = this.user.surname;
            this.email = this.user.email;
            this.username = this.user.username;
            this.password = this.user.password;
        },

        save(event) {
            this.nameError = this.name === '';
            this.surnameError = this.surname === '';
            this.usernameError = this.username === '';
            this.passwordError = this.password === '';

            if (this.nameError || this.surnameError || this.usernameError || this.passwordError) {
                event.preventDefault();
            } else {
                let data = {
                    name: this.name,
                    surname: this.surname,
                    username: this.username,
                    password: this.password,
                    preposition: this.preposition,
                    email: this.email,
                };

                this.alert.saving();

                this.axios.post(this.routes.adminAccountUpdate(this.user.id), data).then(
                    (response) => {
                        ords.use('user').update(response.data, this.user.id);

                        this.alert.success();
                    },
                    (error) => {
                        if (error.response.data.errors.email) {
                            this.alert.ajaxError(error, 'Admin aanmaken mislukt', 'Email al in gebruik');
                        } else if (error.response.data.errors.username) {
                            this.alert.ajaxError(error, 'Admin aanmaken mislukt', 'Gebruikersnaam al in gebruik');
                        } else if (error.response.data.errors.password) {
                            this.alert.ajaxError(
                                error,
                                'Admin aanmaken mislukt',
                                'Wachtwoord moet minimaal 6 tekens zijn',
                            );
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
            }
        },
    },
};
</script>

<style scoped></style>
